import { useContext } from 'react'

import { AppSettingsContext } from '../contexts/app-settings-context'

export const useAppSettings = () => useContext(AppSettingsContext)
